export const INVOICE_CATEGORY_SEQUENCE = {
    IHLs_Curriculum: 1,
    IHLs_Launchpads: 2,
    Go_Live: 3,
    API_Plans: 4,
    UAT_Coursework: 5,
    UAT_Payments: 6,
    UAT_Project: 7,
    Go_Live_Project: 8,
};

export const InvoiceCategorySequenceString = {
    [INVOICE_CATEGORY_SEQUENCE.IHLs_Curriculum]: "IHLs-NETS-FinTech Curriculum",
    [INVOICE_CATEGORY_SEQUENCE.IHLs_Launchpads]: "IHLs-NETS-FinTech Launchpads",
    [INVOICE_CATEGORY_SEQUENCE.Go_Live]: "Go Live Payments Certification",
    [INVOICE_CATEGORY_SEQUENCE.API_Plans]: "API Plans",
    [INVOICE_CATEGORY_SEQUENCE.UAT_Coursework]: "NETS Online Payments Coursework",
    [INVOICE_CATEGORY_SEQUENCE.UAT_Payments]: "UAT Payments Certification",
    [INVOICE_CATEGORY_SEQUENCE.UAT_Project]: "UAT Project Certification",
    [INVOICE_CATEGORY_SEQUENCE.Go_Live_Project]: "Go Live Project Certification",
};